var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskSegment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Risk Segment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.975122,250.000928 L249.975122,0.0646573973 L253.304183,0.0863776488 C362.992538,1.51843695 455.637903,73.6180527 487.812277,172.948209 L250.023133,250.00328 L250.029112,250.019929 L249.975122,250.000928 Z",
    fill: "#0BA88A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskSegment);
export default __webpack_public_path__ + "static/media/Risk-Segment.5fc895e32300ca3637b9e2ba058cea12.svg";
export { ForwardRef as ReactComponent };